import React from 'react';

import useScreen from '@lyearn/core/hooks/useScreen';
import { useTranslation } from '@lyearn/i18n';
import { cn } from '@lyearn/style';
import { Stack } from '@lyearn/ui';
import { PageError } from '@/components/Error';
import ArticleViewer from '@/modules/corporate/modules/article/views/ArticleViewer';
import KnowledgeAssetDetails from '@/modules/knowledge-asset/KnowledgeAssetDetails';
import {
  BookmarkEntityTypeEnum,
  KnowledgeAssetSubTypeEnum,
  ResourceTypeEnum,
} from '@/types/schema';

import { PinnedContentType } from '../../types';
import CoursePreview from '../CoursePreview';
import LessonViewer from '../LessonViewer';
import { articleViewer } from './styles';
function ContentView({ content }: { content: PinnedContentType }) {
  useTranslation(['Article']);
  const { isMobile } = useScreen();

  function renderContent() {
    switch (content.type) {
      case ResourceTypeEnum.Article:
        return (
          <Stack className={articleViewer}>
            <ArticleViewer hideAccessories articleId={content.id} />
          </Stack>
        );
      case ResourceTypeEnum.Course:
        return <CoursePreview courseId={content.id} />;

      case BookmarkEntityTypeEnum.Lesson:
        if (!content.id || !content.parentId) {
          return <PageError />;
        }
        return (
          <LessonViewer
            id={content.id}
            name={content.name}
            parentId={content.parentId}
            parentName={content.parentName}
          />
        );

      case KnowledgeAssetSubTypeEnum.Persona:
      case KnowledgeAssetSubTypeEnum.PersonaJourney:
      case KnowledgeAssetSubTypeEnum.Solution:
      case KnowledgeAssetSubTypeEnum.SolutionWin:
      case KnowledgeAssetSubTypeEnum.SalesConversation:
      case KnowledgeAssetSubTypeEnum.CustomerStory:
        return <KnowledgeAssetDetails assetId={content.id} type={content.type} />;
    }

    // Unsupported content type
    return <PageError />;
  }

  return <Stack className={cn('w-full flex-1', isMobile ? 'p-16' : '')}>{renderContent()}</Stack>;
}

export default ContentView;
